import React from 'react';
import { BRAND, NAV_LINKS } from '../mock';

export default function Footer() {
  return (
    <footer className="border-t border-black/10 py-10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="flex items-center display-font text-sm">
          <span className="brand-square" />
          <span>{BRAND.name}</span>
        </div>
        <div className="text-black/50 text-sm text-center">
          © {new Date().getFullYear()} {BRAND.parent}. All rights reserved.
        </div>
        <a href={`mailto:${BRAND.email}`} className="text-black/60 text-sm hover:text-[#FF5C4D] transition-colors">
          {BRAND.email}
        </a>
      </div>
      <div className="max-w-[1440px] mx-auto px-6 md:px-10 mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs text-black/40">
        {NAV_LINKS.map((l) => (
          <a key={l.label} href={l.href} className="hover:text-black transition-colors">{l.label}</a>
        ))}
      </div>
    </footer>
  );
}
